module.exports = __webpack_public_path__ + "static/AnytimeFitness-28ad24deba02c4736a7d9770d492102a.svg";